<template>
  <div class="containerBox">
    <el-tabs type="border-card" :tab-position="tabPosition" style="height:150px;">
      <el-tab-pane label="换乘查询" @click="gotobm">
        <el-row>
          <el-col :span="12" :offset="6">
            <el-input v-model="start_point" placeholder="请输入起点"></el-input>
            <el-input v-model="end_point" placeholder="请输入终点"></el-input>
            <el-button type="danger" :span="4" size="mini" @click="gotobm" style="float:right;">查询</el-button>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="线路查询">
        <el-row :gutter="0">
          <el-col :span="20">
            <el-col :span="24">
              <el-input v-model="line_name" placeholder="请输入线路名称"></el-input>
            </el-col>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" :span="4" @click="get_bus_line_info">查询</el-button>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="站点查询">
        <el-row :gutter="0">
          <el-col :span="20">
            <el-col :span="24">
              <el-input v-model="station_name" placeholder="请输入站点名称"></el-input>
            </el-col>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" :span="4" @click="get_bus_station_info">查询</el-button>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <div class="show_lines" v-show="show_lines" style="width:100%;height:500px;">
      <div class="linelist" v-for="(item,index) in linedata" :key="index">
        <h1>线路名称：{{item.name}}</h1>
        <ul>
          <li
            v-for="(item0,index0) in item.via_stops"
            :key="index0"
            :title="item0.name"
          >{{item0.name}}</li>
        </ul>
      </div>
    </div>
    <div class="show_station show_lines" style="width:100%;height:500px;" v-show="show_station">
      <div v-for="(item,index) in stationdata" :key="index" style="padding:10px;border-bottom:1px dashed #ccc;">
        <div style="font-size:18px;font-weight:bold;">站点名称：{{item.name}}</div>
        <div style="font-size:14px;line-height:40px;">
          途经线路：
          <span style="height:40px;display:inline-block;background:#f0fcff;margin:5px;padding:0 4px;border-radius:5px;" v-for="(item1,index1) in item.buslines" :key="index1">{{item1.name}}</span>
        </div>
      </div>
    </div>
    <div style="height:500px;overflow:auto;" v-show="state">
      <div style="column-count: 3;column-gap: 10px;padding:10px;">
        <div style="margin-bottom: 10px;border-radius:5px;overflow:hidden;box-shadow: 0px 0px 5px #888888;" v-for="(item,index) in hot_eara" :key="index">
          <div style="background:#0297fb;color:white;padding:5px;">{{item.name}}</div>
          <div v-for="(item2,index2) in item.lines" :key="index2" @click="get_bus_line_info1(item2.line_name)" style="font-size:14px;padding-left:3px;display:flex;margin:4px 0;"> 
            <span style="background:#fb9543;padding:0 3px;border-radius:3px;color:#fff;">{{item2.line_name}}</span><span style="background:#f7faff;flex:1;padding-left:5px;">{{item2.endStation}}-{{item2.startStation}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ipconfig } from "@/assets/js/ipconfig.js";
import Axios from "axios";
import AMap from "AMap";
// var linesearch, map;
export default {
  name: "bus",
  data() {
    return {
      start_point: "",
      end_point: "",
      state: true,
      show_lines: false,
      show_station: false,
      tabPosition: "left",
      line_name: "",
      station_name: "",
      linedata: [],
      stationdata: [],
      hot_eara: []
    };
  },
  created(){
    this.get_default_bus_data();
  },
  mounted() {
   
  },
  methods: {
    gotobm() {
      this.$router.push({
        name: "Bmquery",
        params: {
          start: this.start_point,
          end: this.end_point
        }
      });
    },
    get_bus_line_info() {
      var _this = this;
      var linesearch = new AMap.LineSearch({
        pageIndex: 1, //页码，默认值为1
        pageSize: 20, //单页显示结果条数，默认值为20，最大值为50
        city: "0477", //限定查询城市，可以是城市名（中文/中文全拼）、城市编码，默认值为『全国』
        extensions: "all" //是否返回公交线路详细信息，默认值为『base』
      });

      //执行公交路线关键字查询
      linesearch.search(_this.line_name, function(status, result) {
        _this.state = false;
        _this.show_lines = true;
        _this.show_station = false;
        _this.linedata = result.lineInfo;
      });
    },
    get_bus_line_info1(val) {
      var _this = this;
      var linesearch = new AMap.LineSearch({
        pageIndex: 1, //页码，默认值为1
        pageSize: 20, //单页显示结果条数，默认值为20，最大值为50
        city: "0477", //限定查询城市，可以是城市名（中文/中文全拼）、城市编码，默认值为『全国』
        extensions: "all" //是否返回公交线路详细信息，默认值为『base』
      });

      //执行公交路线关键字查询
      linesearch.search(val, function(status, result) {
        _this.state = false;
        _this.show_lines = true;
        _this.show_station = false;
        _this.linedata = result.lineInfo;
      });
    },
    get_bus_station_info() {
      var _this = this;
      var station = new AMap.StationSearch({
        pageIndex: 1, //页码，默认值为1
        pageSize: 200, //单页显示结果条数，默认值为20，最大值为50
        city: "0477" //限定查询城市，可以是城市名（中文/中文全拼）、城市编码，默认值为『全国』
      });
      //执行关键字查询
      station.search(_this.station_name, function(status, result) {
        //打印状态信息status和结果信息result
        //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误。
        _this.state = false;
        _this.show_lines = false;
        _this.show_station = true;
        _this.stationdata = result.stationInfo;
      });
    },
    get_default_bus_data() {
      Axios.get(`http://${ipconfig}/app/isweb/bus/searchBusInfo?innerMS`).then(
        res => {
          // debugger;
          // console.log(JSON.stringify(res.data.data.areas))
          this.hot_eara = res.data.data.areas;
        }
      );
    }
  }
};
</script>
<style scoped>
.containerBox {
  height: 650px;
}
/* .linelist{border:1px solid red;display: block;margin-top: 10px;} */
.show_lines {
  overflow: auto;
}
.linelist {
  margin: 10px;
  background: rgba(249, 250, 252, 0.5);
  padding-bottom: 5px;
}
.linelist h1 {
  margin-bottom: 5px;
}
.linelist ul li {
  display: inline-block;
  width: 20px;
  border: 1px solid rgba(1, 152, 251, 0.5);
  font-size: 12px;
  line-height: 14px;
  vertical-align: top;
  text-align: center;
  height: 100px;
  overflow: hidden;
  margin-right: 2px;
}
.stationlist {
  border: 1px solid red;
  width: calc(100% / 3 - 20px);
  /* margin: 10px; */
}
</style>


// WEBPACK FOOTER //
// src/pages/bus/index.vue


// WEBPACK FOOTER //
// src/pages/bus/index.vue